import TableViewToggles, { type TableViewTogglesViewType } from '@rio-cloud/rio-uikit/TableViewToggles';
import type { JSX } from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import {
    createGoogleAnalyticsEvent,
    dataLayerPush,
    TrackingAction,
    TrackingCategory,
} from '../../../configuration/setup/googleTagManager';
import type { State } from '../../../reducers';
import { getTableViewMode, tableSettingsActions } from './tablesettings/redux/tablesettings.redux';
import type { TableModeButtonDispatchProps, TableModeButtonProps, TableModeButtonStateProps } from './types';

const TableModeButtons = (props: TableModeButtonProps): JSX.Element => {
    const { viewType, onViewTypeChange } = props;

    const onViewTypeChangeTracked = (viewMode: TableViewTogglesViewType): void => {
        onViewTypeChange(viewMode);
        dataLayerPush(
            createGoogleAnalyticsEvent(TrackingCategory.ANY_TABLE, TrackingAction.CHANGE_TABLE_VIEW_MODE, viewMode)
        );
    };

    return (
        <div className={'btn-group'}>
            <TableViewToggles initialViewType={viewType} onViewTypeChange={onViewTypeChangeTracked} />
        </div>
    );
};

const mapStateToProps = (state: State): TableModeButtonStateProps => ({
    viewType: getTableViewMode(state),
});

const mapDispatchToProps = (dispatch: Dispatch): TableModeButtonDispatchProps => ({
    onViewTypeChange: (viewMode: TableViewTogglesViewType): void => {
        dispatch(tableSettingsActions.setTableViewMode(viewMode));
    },
});

export const TableModeButtonContainer = connect(mapStateToProps, mapDispatchToProps)(TableModeButtons);
